import { communityReviewEndpointIds } from 'root/src/server/modules/communityReview/communityReview.fixture';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { CommunityReviewStatus } from 'root/src/shared/communityReview/communityReview.types';
export const searchCommunityReviewsAdminEndpoint = {
    [communityReviewEndpointIds.SEARCH_COMMUNITY_REVIEWS_ADMIN]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                page: { type: 'number' },
                limit: { type: 'number' },
                sort: {
                    type: 'object',
                    properties: {
                        field: { type: 'string', enum: ['created', 'modified', 'status'] },
                        order: { type: 'string', enum: ['asc', 'desc'] },
                    },
                },
                reviewerId: { type: 'string' },
                status: { type: 'string', enum: Object.values(CommunityReviewStatus) },
                projectId: { type: 'string' },
                dropId: { type: 'string' },
            },
        },
    },
};
